"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertGameStateFromSerializable = exports.convertGameStateToSerializable = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const convertGameStateToSerializable = ({ feeRateBips, currentRound, oracleAccount, gameVault, advanceBalance, advanceReward, totalFees, totalFeesClaimed, advanceMinBalanceRequired, minTotalRequired, decimalPlaces, }) => {
    return {
        feeRateBips,
        currentRound,
        oracleAccount: oracleAccount.toBase58(),
        gameVault: gameVault.toBase58(),
        advanceBalance: advanceBalance.toString(),
        advanceReward: advanceReward.toString(),
        totalFees: totalFees.toString(),
        totalFeesClaimed: totalFeesClaimed.toString(),
        advanceMinBalanceRequired: advanceMinBalanceRequired.toString(),
        minTotalRequired: minTotalRequired.toString(),
        decimalPlaces,
    };
};
exports.convertGameStateToSerializable = convertGameStateToSerializable;
const convertGameStateFromSerializable = ({ feeRateBips, currentRound, oracleAccount, gameVault, advanceBalance, advanceReward, totalFees, totalFeesClaimed, advanceMinBalanceRequired, minTotalRequired, decimalPlaces, }) => {
    return {
        feeRateBips,
        currentRound,
        oracleAccount: new web3_js_1.PublicKey(oracleAccount),
        gameVault: new web3_js_1.PublicKey(gameVault),
        advanceBalance: new anchor_1.BN(advanceBalance),
        advanceReward: new anchor_1.BN(advanceReward),
        totalFees: new anchor_1.BN(totalFees),
        totalFeesClaimed: new anchor_1.BN(totalFeesClaimed),
        advanceMinBalanceRequired: new anchor_1.BN(advanceMinBalanceRequired),
        minTotalRequired: new anchor_1.BN(minTotalRequired),
        decimalPlaces,
    };
};
exports.convertGameStateFromSerializable = convertGameStateFromSerializable;
